export default __webpack_public_path__ + "media/images/client-logos/hbs-bae915249333f7fcaa8f141bddc6633c.png";